((Drupal, Cookiebot) => {
  // ---------------------------------------------------
  // Drupal Behavior: BigCookieBotBlock
  // ---------------------------------------------------
  Drupal.behaviors.BigCookieBotBlock = {
    attach(context) {
      // Select all elements with the .big-cookiebot-link class in the provided context.
      const links = (context || document).querySelectorAll(
        '.big-cookiebot-link',
      );

      for (const link of links) {
        // Use a data attribute to prevent attaching multiple event listeners.
        if (!link.hasAttribute('data-bc-listener-attached')) {
          link.addEventListener('click', (e) => {
            // Call the appropriate Cookiebot method based on the button's classes.
            if (link.classList.contains('big-cookiebot-renew')) {
              Cookiebot.renew();
            }
            if (link.classList.contains('big-cookiebot-withdraw')) {
              Cookiebot.withdraw();
            }
            e.preventDefault();
          });
          link.setAttribute('data-bc-listener-attached', 'true');
        }
      }
    },
  };

  // ---------------------------------------------------
  // Cookiebot Dialog Customization
  // ---------------------------------------------------

  /**
   * Utility function to get an element by ID with a fallback.
   * @param {string} id - The ID of the element.
   * @returns {HTMLElement|null}
   */
  const getElement = (id) => document.getElementById(id);

  /**
   * Handles customization of the Cookiebot dialog display.
   */
  const CookiebotOnDialogDisplay = () => {
    // Cache frequently used elements.
    const selectionWrapper = getElement(
      'CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper',
    );
    const detailsWrapper = getElement(
      'CybotCookiebotDialogBodyLevelDetailsWrapper',
    );
    const buttonsContainer = getElement('CybotCookiebotDialogBodyLevelButtons');
    const speichernButton = getElement(
      'CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection',
    );

    // Ensure all required elements exist.
    if (
      !selectionWrapper ||
      !detailsWrapper ||
      !buttonsContainer ||
      !speichernButton
    ) {
      console.warn(
        'CookiebotOnDialogDisplay: One or more required elements are missing.',
      );
      return;
    }

    // Create the "Einstellungen" (Settings) button.
    const btnSettings = document.createElement('a');
    btnSettings.textContent = 'Einstellungen'; // Using textContent for plain text.
    btnSettings.className = 'CybotCookiebotDialogBodyButton';
    btnSettings.id =
      'CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSettings';

    // Toggle the visibility of the buttons container on click.
    btnSettings.addEventListener(
      'click',
      () => {
        buttonsContainer.classList.toggle('hidden');
      },
      false,
    );

    // Insert the Settings button at the beginning of the selection wrapper.
    selectionWrapper.prepend(btnSettings);

    // Move the "Speichern" button to the details section.
    detailsWrapper.prepend(speichernButton);

    // Hide the buttons container by default.
    buttonsContainer.classList.add('hidden');
  };

  // Attach the CookiebotOnDialogDisplay function to the custom event.
  window.addEventListener(
    'CookiebotOnDialogDisplay',
    CookiebotOnDialogDisplay,
    false,
  );
})(Drupal, Cookiebot);
